import { IApplicationState } from '../../../types/redux';

/**
 * Возвращает состояние модалки поиска
 */
export const selectSearchingModalStatus = ({ settings: { isSearchingModalOpened } }: IApplicationState) =>
  isSearchingModalOpened;
